webpackJsonp([170786371021445],{

/***/ 740:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/Users/colemerrick/passion/project_surf_helmet/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. I will answer to the message as soon as possible.</p>","frontmatter":{"title":"Success","subTitle":null}},"footnote":{"id":"/Users/colemerrick/passion/project_surf_helmet/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>© 2023 Project Surf Helmet</li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{"slug":"/success/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---success-d93fd04ea83f073ce5b9.js